module.exports = __webpack_public_path__ + "media/images/brands/brand-mj-9b62f7e6a19c80c65d316a6637fd9d4a.jpg";